export const timeout = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

export const formatBlogDate = (isoString, t) => {
	const date = new Date(isoString);
	const monthIndex = date.getMonth();
	const monthName = t(`full.month${monthIndex}`);
	return `${monthName} ${date.getDate()}, ${date.getFullYear()}`;
};

export const formatProductReviewDate = (isoString, t) => {
	const date = new Date(isoString);
	const monthIndex = date.getMonth();
	const monthName = t(`full.month${monthIndex}`);
	// const hours = date.getHours().toString().padStart(2, '0');
	// const minutes = date.getMinutes().toString().padStart(2, '0');
	return `${date.getDate()} ${monthName} ${date.getFullYear()}`;
};

export const formatOrderListDate = (isoString) => {
	const date = new Date(isoString);
	const monthIndex = date.getMonth();
	return `${date.getDate().toString().padStart(2, '0')}/${(monthIndex + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
};
